import { Draft } from "immer";

import {
  getCurrentPathFromLocation,
  isValidCollaboration,
  isValidSubfolder,
  isValidPath,
} from "pages/Rules/Form/Steps/StorageFilepath/utils";
import { isBlank } from "utils/string";

import { FolderType } from "pages/Rules/Form/Steps/StorageFilepath/FilepathSelector/types";
import { State } from "../../types";
import { getCloudStorage as getStorage } from "pages/Rules/Form/context/ruleSelectors";

export default function validate(draft: Draft<State>) {
  const storage = getStorage(draft.rule);
  const currentPath = getCurrentPathFromLocation(storage.location);

  if (storage.location.copyPolicy) {
    draft.steps.storageFilepath.valid =
      !isBlank(storage.location.copyPolicy) && isValidSubfolder(storage);
  } else {
    const validPath =
      storage.location?.parentId !== FolderType.SOURCE_FOLDER
        ? isValidPath(currentPath)
        : true;
    draft.steps.storageFilepath.valid =
      validPath && isValidSubfolder(storage) && isValidCollaboration(storage);
  }
}
